<template>
    <DCard
        padding
    >
        <Form
            :errors="errors"
            :date-units="dateUnits"
            @form-submitted="submitForm"
        />
    </DCard>
</template>

<script setup>
import { route } from '~@/Composables/route'
import Form from '~@/Components/Settings/DhpExtensions/Form.vue'

defineProps({
    dhpExtension: {
        type: Object,
        default: () => {
            return {}
        }
    },
    dateUnits: {
        type: Array,
        default: () => {
            return []
        }
    },
    errors: {
        type: Object,
        default: () => {
            return {}
        }
    }
})

function submitForm (form) {
    form.post(route('settings.dhp-extensions.store'))
}

</script>
